export const CHROME_EXTENSION_URL = `https://chrome.google.com/webstore/detail/cosy/${process.env.NEXT_PUBLIC_CHROME_EXTENSION_ID}`;
